// src/components/ProtectedRoute/Admin/Consoles/Pages/InstitutesConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import repositoriesPlugin from "../Plugins/repositories.plugin";

import DialogRepository from "../../Dialogs/DialogRepository";

export default function InstitutesConsole() {
  return (
    <ConsolePageFrame
      title="Institutes"
      plugin={repositoriesPlugin}
      searchPlaceholder="Search institutes (acronym / name / taxapad)"
      columnsBuilder={({ onEdit }) => repositoriesPlugin.columns({ onEdit })}
      renderAddDialog={({ onClose }) => <DialogRepository open onClose={onClose} />}
      renderEditDialog={({ row, onClose }) => (
        <DialogRepository open repository={row} onClose={onClose} />
      )}
      toastMessages={{ create: "Institute created", update: "Institute updated" }}
    />
  );
}
